import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=63ba3252&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"
import style0 from "./radio.vue?vue&type=style&index=0&id=63ba3252&prod&lang=less&scoped=true"
import style1 from "./radio.vue?vue&type=style&index=1&id=63ba3252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba3252",
  null
  
)

export default component.exports